const shopify = {
  inputCustomerName: 'Nombre',
};


module.exports = shopify;
